import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#6B7783',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const PRIMARY = {
  lighter: '#D1E9FC',
  light: '#76B0F1',
  main: '#2065D1',
  dark: '#103996',
  darker: '#294E99',
  contrastText: '#fff',
  mainColor: '#2F5BB2',
  background: '#D7E3FB',
  text: '#4482dd',
  border: '#b5d8f2',
  icon: '#3f80e2',
};

const SECONDARY = {
  lighter: '#f8f8f8',
  light: '#ebebeb',
  main: '#3366FF',
  dark: '#1939B7',
  darker: '#091A7A',
  contrastText: '#fff',
  mainColor: '#4482FF',
};

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
  alternateText: '#edeff1',
};

const SUCCESS = {
  lighter: '#D8FDD7',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#35B430',
  darker: '#08660D',
  contrastText: GREY[800],
};

const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  alt: '#FF7F50',
  contrastText: GREY[800],
};

const ERROR = {
  lighter: '#FFAFBF',
  light: '#F2778E',
  main: '#ED4E64',
  dark: '#C62343',
  darker: '#9B2037',
  contrastText: '#fff',
};

const GRAPH = {
  red: '#ED4E64',
  darkRed: '#C62343',
  yellow: '#f3bc00',
  blue: '#4482FF',
  darkBlue: '#294E99',
  green: '#31e0c4',
  darkGreen: '#00af82',
};

const IMAGE_BG = {
  emptyImgOneLight: '#aeb8c2',
  emptyImgOneDark: '#262626',
  emptyImgTwoLight: '#f5f5f7',
  emptyImgTwoDark: '#595959',
  emptyImgThreeLight: '#dce0e6',
  emptyImgThreeDark: '#434343',
  emptyImgFourLight: '#dce0e6',
  emptyImgFourDark: '#434343',
  emptyImgFiveLight: '#fff',
  emptyImgFiveDark: '#1c1c1c',
  emptyImgSixLight: '#f5f5f5',
  emptyImgSixDark: '#fff',
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: GREY[800],
    secondary: GREY[600],
    disabled: GREY[500],
    greyed: '#AAAAAA',
  },
  background: {
    paper: '#fff',
    default: GREY[100],
    neutral: GREY[200],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
  imageBackground: IMAGE_BG,
  graph: GRAPH,
};

export default palette;
